// extracted by mini-css-extract-plugin
module.exports = {"supportTab":"SupportTab_supportTab__oBUo5","title":"SupportTab_title__d1QHW","content":"SupportTab_content__2huWo","link":"SupportTab_link__lCfBf"};